<template>
<div>
    <div v-show="!isEditing">
        <div>
            <div class="card-header">
                <p class="card-header-title">{{ data.title }}</p>
            </div>
            <div class="card-content" style="padding: 10px;">
                <div class="content">
                    <strong>{{ data.message }}</strong>
                    <br/>
                    Repeat on: {{ showRepeatDays(data.repeatOn) }}
                    <br/>
                    Time: {{ showTime(data.repeatTime) }}
                </div>
            </div>
            <footer class="card-footer">
                <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
            </footer>
        </div>
    </div>

    <div v-show="isEditing">        
        <div class="card-header">
            <p class="card-header-title">Edit Notification</p>
        </div>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <div class="control">
                        <input class="input is-success" type="text" placeholder="Title" v-model="data.title">
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <input class="input is-success" type="text" placeholder="Message" v-model="data.message">
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <div class="myLabel">Repeat on: </div>
                        <div class="myInput">
                            <b-checkbox native-value="1" v-model="repeatOnArray">Monday</b-checkbox>
                            <b-checkbox native-value="2" v-model="repeatOnArray">Tuesday</b-checkbox>
                            <b-checkbox native-value="3" v-model="repeatOnArray">Wednesday</b-checkbox>
                            <b-checkbox native-value="4" v-model="repeatOnArray">Thursday</b-checkbox>
                            <b-checkbox native-value="5" v-model="repeatOnArray">Friday</b-checkbox>
                            <b-checkbox native-value="6" v-model="repeatOnArray">Saturday</b-checkbox>
                            <b-checkbox native-value="0" v-model="repeatOnArray">Sunday</b-checkbox>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <div class="myLabel">Time:</div> <div class="myInput"><b-select id="dataType" name="dataType" v-model="data.repeatTime">
                            <option value="7">7 a.m.</option>
                            <option value="8">8 a.m.</option>
                            <option value="9">9 a.m.</option>
                            <option value="10">10 a.m.</option>
                            <option value="11">11 a.m.</option>
                            <option value="12">12 p.m.</option>
                            <option value="13">1 p.m.</option>
                            <option value="14">2 p.m.</option>
                            <option value="15">3 p.m.</option>
                            <option value="16">4 p.m.</option>
                            <option value="17">5 p.m.</option>
                            <option value="18">6 p.m.</option>
                            <option value="19">7 p.m.</option>
                            <option value="20">8 p.m.</option>
                            <option value="21">9 p.m.</option>
                            <option value="22">10 p.m.</option>
                            <option value="23">11 p.m.</option>
                            <option value="0">12 a.m.</option>
                            <option value="1">1 a.m.</option>
                            <option value="2">2 a.m.</option>
                            <option value="3">3 a.m.</option>
                            <option value="4">4 a.m.</option>
                            <option value="5">5 a.m.</option>
                            <option value="6">6 a.m.</option>
                        </b-select></div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <div class="myLabel">Status:</div> 
                        <div class="myInput">
                            <b-radio v-model="data.status" native-value="1">
                                Active
                            </b-radio>
                            <b-radio v-model="data.status" native-value="0">
                                Inactive
                            </b-radio>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <button class='button is-primary' v-on:click="updateData(data,repeatOnArray)">Update</button>
                    <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['data'],
    components:{
    },
    data() {
        return {
            isEditing: false,
            repeatOnArray: []
        };
    },
    created() {
        var temp = this.data.repeatOn.split(",")
        this.repeatOnArray = temp
    },
    methods: {
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data,repeatOnArray) {
            data.repeatOn = repeatOnArray.join(",")
            this.$emit('update-data', data);
            this.isEditing = false;
        },
        showTime(time){
            if (time == 24){
                return "12 a.m."
            }else if (time == 12){
                return "12 p.m."
            }else if (time < 12){
                return time + " a.m."
            }else{
                return time - 12 + " p.m."
            }
        },
        showRepeatDays(days){
            var getDays = days.split(",")
            var daysDisplay = "";
            for (var i = 0; i < getDays.length; i++){
                daysDisplay = daysDisplay + this.displayDayOfWeek(getDays[i]) + ", "
            }
            return daysDisplay;
        },
        displayDayOfWeek(day){
            if (day == 1){
                return "Monday"
            }else if (day == 2){
                return "Tuesday"
            }else if (day == 3){
                return "Wednesday"
            }else if (day == 4){
                return "Thursday"
            }else if (day == 5){
                return "Friday"
            }else if (day == 6){
                return "Saturday"
            }else {
                return "Sunday"
            }
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Manage/Notifications/DataView.vue